import React from 'react';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormLangInput from 'components/forms/FormLangInput';
import FormLangRichEditor from 'components/forms/FormLangRichEditor';

class DocTypePageInfoData extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.defaultFieldTree = ['pageInfos', props.index];
  }

  render() {
    const {
      intl: { messages },
      data,
      index,
      disabled,
    } = this.props;

    return (
      <Row>
        <Col xs={12} md={6}>
          <div class="panel panel-transparent">
            <div class="panel-body">
              <p>
                {messages.page} {index + 1}
              </p>
              <FormLangInput
                label={messages.name}
                name="name"
                value={data.getName()}
                meta={data.getNameMetaInformation()}
                validation={data.getNameValidationResult()}
                onChange={this.updateEntity}
                disabled={disabled}
              />
              <FormLangRichEditor
                id={index}
                name="description"
                label={messages.description}
                value={data.getDescription()}
                meta={data.getDescriptionMetaInformation()}
                validation={data.getDescriptionValidationResult()}
                onChange={this.updateEntity}
                disabled={disabled}
              />
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

export default injectIntl(DocTypePageInfoData);
